import login from './login';

export default {
  language: 'nl-NL',
  country: 'nl',
  name: 'Nederlands',
  embeddedLocale: login,
};
